import { createContext, useContext, type PropsWithChildren } from 'react';

import { type TemplateDetailsHost } from './template-details-host';

const TemplateDetailsHostContext = createContext<TemplateDetailsHost | null>(null);

/** Mounted once by the page and the modal so inner modules share one host. */
export const TemplateDetailsHostProvider = ({
  host,
  children,
}: PropsWithChildren<{ host: TemplateDetailsHost }>) => (
  <TemplateDetailsHostContext.Provider value={host}>
    {children}
  </TemplateDetailsHostContext.Provider>
);

/** Throws when a template details module renders outside the provider. */
export const useTemplateDetailsHost = (): TemplateDetailsHost => {
  const host = useContext(TemplateDetailsHostContext);
  if (!host) {
    throw new Error('Template details host read outside TemplateDetailsHostProvider');
  }
  return host;
};
